import React,{useState} from 'react';
import StatusBadge from './StatusBadge';
import {fmt,fmt4,formatarData,tipoEntregaLabel} from '../utils';

function Progresso({pedido}){
  const itens=pedido.itens||[];
  const tot=itens.length;
  const ret=itens.filter(i=>i.status==='RETIRADO').length;
  if(!tot||ret===0)return null;
  const perc=Math.round(ret/tot*100);
  return(<div style={{marginTop:6}}>
    <div style={{display:'flex',justifyContent:'space-between',fontSize:10,color:'var(--z-text-muted)',marginBottom:2}}>
      <span>Retirado: {ret}/{tot} itens</span><span>{perc}%</span>
    </div>
    <div style={{height:4,background:'var(--z-border)',borderRadius:2}}>
      <div style={{height:'100%',width:perc+'%',background:perc===100?'#16a34a':'var(--z-blue)',borderRadius:2}}/>
    </div>
  </div>);
}

function Detalhe({pedido,onEditar,onMudarStatus,onAbrirRetirada,onRecarregar}){
  const itensPendentes=(pedido.itens||[]).filter(i=>i.status!=='RETIRADO');
  return(<tr className='tr-dropdown'><td colSpan={9}><div style={{padding:'16px 20px',background:'#f8faff'}}>
    <table style={{width:'100%',fontSize:12,marginBottom:12}}>
      <thead>
        <tr style={{background:'var(--z-bg-page)'}}>
          <th style={{padding:'4px 8px',textAlign:'left',width:100}}>Codigo</th>
          <th style={{padding:'4px 8px',textAlign:'left'}}>Produto</th>
          <th style={{padding:'4px 8px',textAlign:'right',width:80}}>Qtd</th>
          <th style={{padding:'4px 8px',textAlign:'right',width:80}}>Retirado</th>
          <th style={{padding:'4px 8px',textAlign:'right',width:80}}>Pendente</th>
          <th style={{padding:'4px 8px',textAlign:'right',width:100}}>Unit</th>
          <th style={{padding:'4px 8px',textAlign:'right',width:100}}>Total</th>
        </tr>
      </thead>
      <tbody>
        {(pedido.itens||[]).map(it=>{
          const pend=parseFloat(it.quantidade_pendente||0);
          const ret=parseFloat(it.quantidade_retirada||0);
          return(
            <tr key={it.id} style={{borderBottom:'1px solid var(--z-border)',background:it.status==='RETIRADO'?'#f0fdf4':''}}>
              <td style={{padding:'4px 8px',fontFamily:'monospace',fontSize:11,color:'var(--z-text-muted)',whiteSpace:'nowrap'}}>{it.produto_codigo}</td>
              <td style={{padding:'4px 8px'}}>
                {it.produto_nome}
                {it.observacao&&<div style={{fontSize:11,color:'var(--z-text-muted)',fontStyle:'italic'}}>{it.observacao}</div>}
              </td>
              <td style={{padding:'4px 8px',textAlign:'right',whiteSpace:'nowrap'}}>{fmt4(it.quantidade)} {it.produto_unidade}</td>
              <td style={{padding:'4px 8px',textAlign:'right',color:ret>0?'#16a34a':'var(--z-text-muted)'}}>{ret>0?fmt4(ret):'-'}</td>
              <td style={{padding:'4px 8px',textAlign:'right',fontWeight:pend>0?600:400,color:pend>0?'var(--z-blue)':'#16a34a'}}>{pend>0?fmt4(pend):'OK'}</td>
              <td style={{padding:'4px 8px',textAlign:'right'}}>R$ {fmt(it.preco_unit)}</td>
              <td style={{padding:'4px 8px',textAlign:'right',fontWeight:600}}>R$ {fmt(it.valor_total)}</td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr style={{borderTop:'2px solid var(--z-blue)'}}>
          <td colSpan={6} style={{padding:'6px 8px',textAlign:'right',fontWeight:700}}>TOTAL</td>
          <td style={{padding:'6px 8px',textAlign:'right',fontWeight:700,color:'var(--z-blue)'}}>R$ {fmt(pedido.valor_total)}</td>
        </tr>
      </tfoot>
    </table>
    {(pedido.retiradas||[]).length>0&&(
      <div style={{marginBottom:8,fontSize:12}}>
        <strong style={{color:'var(--z-text-secondary)'}}>Retiradas: </strong>
        {pedido.retiradas.map(r=>(
          <span key={r.id} style={{marginLeft:6,padding:'1px 8px',background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:4,fontSize:11}}>
            {new Date(r.data_retirada).toLocaleDateString('pt-BR')} - {r.retirado_por}
          </span>
        ))}
      </div>
    )}
    {pedido.tags_internas&&<div style={{fontSize:12,color:'var(--z-text-secondary)',marginBottom:8,padding:'6px 10px',background:'#fffbeb',borderRadius:4,border:'1px solid #fde68a'}}><strong>Tags:</strong> {pedido.tags_internas}</div>}
    {pedido.observacoes&&<div style={{fontSize:12,color:'var(--z-text-secondary)',marginBottom:8}}>Obs: {pedido.observacoes}</div>}
    {pedido.endereco_entrega&&<div style={{fontSize:12,marginBottom:8}}><i className='ti ti-map-pin'/> {pedido.endereco_entrega}</div>}
    <div style={{display:'flex',gap:8,flexWrap:'wrap',borderTop:'1px solid var(--z-border)',paddingTop:10}}>
      <button className='btn btn-secondary' style={{fontSize:12}} onClick={()=>onEditar(pedido)}><i className='ti ti-edit'/> Editar</button>
      {pedido.status==='ORCAMENTO'&&<button className='btn btn-primary' style={{fontSize:12}} onClick={()=>onMudarStatus(pedido.id,'CONFIRMADO')}>Confirmar Pedido</button>}
      {pedido.status==='CONFIRMADO'&&<button className='btn btn-primary' style={{fontSize:12}} onClick={()=>onMudarStatus(pedido.id,'EM_PRODUCAO')}>Iniciar Producao</button>}
      {pedido.status==='EM_PRODUCAO'&&<button className='btn btn-primary' style={{fontSize:12}} onClick={()=>onMudarStatus(pedido.id,'PRONTO')}>Marcar Tudo Pronto</button>}
      {itensPendentes.length>0&&['CONFIRMADO','EM_PRODUCAO','PRONTO'].includes(pedido.status)&&(
        <button className='btn btn-primary' style={{fontSize:12}} onClick={()=>onAbrirRetirada(pedido)}>
          <i className='ti ti-package-export'/> Registrar Retirada
        </button>
      )}
      {pedido.status==='PRONTO'&&pedido.tipo_entrega==='ENTREGA'&&<button className='btn btn-primary' style={{fontSize:12}} onClick={()=>onMudarStatus(pedido.id,'ENTREGUE')}>Marcar Entregue</button>}
    </div>
  </div></td></tr>);
}

export default function LinhaPedido({pedido,onEditar,onExcluir,onMudarStatus,onAbrirRetirada,onRecarregar}){
  const [aberto,setAberto]=useState(false);
  const temRet=(pedido.retiradas||[]).length>0;
  return(<React.Fragment>
    <tr className='tr-expandable' onClick={()=>setAberto(o=>!o)}>
      <td style={{fontFamily:'monospace',fontSize:12,color:'var(--z-text-muted)'}}>#{pedido.id}</td>
      <td><strong>{pedido.cliente_nome}</strong>{temRet&&<Progresso pedido={pedido}/>}</td>
      <td style={{fontSize:13,color:'var(--z-text-secondary)'}}>{formatarData(pedido.data_pedido)}</td>
      <td style={{fontSize:13,fontWeight:pedido.prazo_previsto?600:400,color:pedido.prazo_previsto?'var(--z-text-primary)':'var(--z-text-muted)'}}>{formatarData(pedido.prazo_previsto)}</td>
      <td><span style={{fontSize:11,padding:'2px 8px',borderRadius:4,background:pedido.tipo_entrega==='RETIRADA'?'#e0f2fe':'#f0fdf4',color:pedido.tipo_entrega==='RETIRADA'?'#0284c7':'#16a34a'}}>{tipoEntregaLabel(pedido)}</span></td>
      <td><StatusBadge status={pedido.status}/></td>
      <td style={{maxWidth:200}}>{pedido.tags_internas&&pedido.tags_internas.split(/[,\n]/).filter(t=>t.trim()).map((t,i)=><span key={i} style={{fontSize:10,padding:'1px 6px',borderRadius:10,background:'#e0f2fe',color:'#0284c7',marginRight:3,display:'inline-block'}}>{t.trim()}</span>)}</td>
      <td style={{textAlign:'right',fontWeight:600}}>R$ {fmt(pedido.valor_total)}</td>
      <td style={{textAlign:'right'}}><button className='btn btn-danger' style={{fontSize:11,padding:'2px 8px'}} onClick={e=>{e.stopPropagation();onExcluir(pedido.id);}}>Excluir</button></td>
    </tr>
    {aberto&&<Detalhe pedido={pedido} onEditar={onEditar} onMudarStatus={onMudarStatus} onAbrirRetirada={onAbrirRetirada} onRecarregar={onRecarregar}/>}
  </React.Fragment>);
}


